import {
    GET_PERMISSIONS_REQUEST,
    GET_PERMISSIONS_SUCCESS,
    GET_PERMISSIONS_ERROR,
} from 'constants/ActionTypes';

const initialState = {
    list: [],
    listLoading: false,
    current: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PERMISSIONS_REQUEST:
            return {
                ...state,
                listLoading: true,
            };
        case GET_PERMISSIONS_SUCCESS:
            return {
                ...state,
                listLoading: false,
                list: action.payload,
            };
        case GET_PERMISSIONS_ERROR:
            return {
                ...state,
                listLoading: false,
                list: [],
            };
        default:
            return {
                ...state,
            };
    }
}
